import { useState, useEffect } from 'react';

import { fetchCognitoUserToken } from '../utils/user';

const backendURL = process.env.REACT_APP_BACKEND_URL;
const shopifyAccessToken = process.env.REACT_APP_SHOPIFY_STOREFRONT_API_TOKEN;

const useApiCart = (sCartId) => {
  const [apiCart, setApiCart] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getApiCart = async (sCartId) => {
      let headers = {
        'Content-Type': 'application/json',
        'x-shop-key': shopifyAccessToken,
      };

      const accessToken = await fetchCognitoUserToken();
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      const strippedCartId = sCartId.replace('gid://shopify/Cart/', '');

      try {
        const response = await fetch(`${backendURL}/shop/cart/${encodeURIComponent(strippedCartId)}`, {
          method: 'GET',
          headers: headers,
        });

        if (response.ok) {
          const acr = await response.json();
          setApiCart(acr);
        } else {
          if (response.status === 404) {
            setApiCart(null);
          } else {
            throw new Error('Unable to retrieve cart');
          }
        }
      } catch (error) {
        console.error('/shop/useApiCart.js- useApiCart - Unable to retrieve cart', sCartId);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    if (sCartId) {
      getApiCart(sCartId);
    }
  }, [sCartId]);

  return { apiCart, loading, error };
};

export default useApiCart;
